import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { useDropdownMenuTooltip } from '@/pages/telephony/numberBlocks/add/hooks/useDropdownMenuTooltip';

const OutboundCallerIDField = ({
    darkMode,
    values,
    setFieldValue,
    outboundCallerIDOptions,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { tooltipPlacement, onMouseDown, onMenuClose } =
        useDropdownMenuTooltip();

    // Hide field while options are loading (undefined) or when there are no options (empty array)
    const isLoading = outboundCallerIDOptions === undefined;
    const noOptions =
        outboundCallerIDOptions && outboundCallerIDOptions.length === 0;

    // Don't render anything during loading, when no options available, or no companyID
    // This prevents layout shifts and overlapping issues
    if (!values?.companyID || isLoading || noOptions) {
        return null;
    }

    // DropDown matches options by `id`, so mirror `telephoneNumber` onto `id` here.
    const options = outboundCallerIDOptions.map((option) => ({
        ...option,
        id: option.telephoneNumber,
    }));

    return (
        <Box
            sx={{ marginTop: '2rem', marginBottom: '2rem' }}
            // border='2px solid red'
            borderRadius="8px"
            p="0.2rem">
            <FormControl
                sx={{ margin: '0 !important' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={stackStyling(true)}>
                    <Box>
                        <FormLabel sx={formLabelStyling(darkMode)}>
                            Outbound Caller ID
                        </FormLabel>
                        <Text sx={descriptionStyling} maxWidth={250}>
                            This will overwrite the CLI presentation for ALL
                            numbers in the block.
                        </Text>
                    </Box>
                    <Box flex="1" minWidth={0} onMouseDown={onMouseDown}>
                        <DropDown
                            darkMode={darkMode}
                            name="cliPresentation"
                            data={options}
                            shownValue="display"
                            currentId={values.cliPresentation}
                            handleSelectChange={(item) =>
                                setFieldValue('cliPresentation', item?.id ?? '')
                            }
                            width="100%"
                            onMenuClose={onMenuClose}
                        />
                    </Box>
                    {isHovered && (
                        <FieldToolTip
                            label="Warning: This will override CLI presentation for all numbers in this block"
                            ariaLabel="outbound-caller-id-tip"
                            left="25px"
                            top="25px"
                            placement={tooltipPlacement}
                        />
                    )}
                </Stack>
            </FormControl>
        </Box>
    );
};

export default OutboundCallerIDField;
